export default [
  {
    title: '账号ID',
    key: 'userId',
    width: 60
  },
  {
    title: '角色',
    key: 'roleName',
    type: 'basic',
    width: 100
  },
  {
    title: '充值金额',
    key: 'orderMoney',
    sortable: 'custom',
    type: 'basic',
    width: 56
  },
  {
    title: '充值时间',
    key: 'postTime',
    sortable: 'custom',
    type: 'basic',
    width: 100
  },
  {
    title: '角色创建时间',
    key: 'roleTime',
    sortable: 'custom',
    type: 'basic',
    width: 100
  },
  {
    title: '创角（账号）时间',
    key: 'firstRoleTime',
    type: 'basic',
    width: 100
  },
  {
    title: '区服',
    key: 'serverName',
    type: 'basic',
    width: 92
  },
  {
    title: '订单号',
    key: 'orderNo',
    type: 'basic',
    width: 160
  },
  {
    title: '充值方式',
    key: 'payTypeName',
    type: 'basic',
    width: 62
  },
  {
    title: '状态',
    key: 'status',
    type: 'basic',
    width: 50
  }
]
